import DoctorSlider from "../components/DoctorSlider";
import Fotter from "../components/Fotter";
import MedicineCover from "../components/MedicineCover";
import MedicineSellingPage from "../components/MedicineSellingPage";
import Navbar from "../components/Navbar";

function Home() {
  return (
<>

<Navbar/>
<MedicineCover/>
<DoctorSlider/>
<MedicineSellingPage/>
<Fotter/>
</>

);
}

export default Home;
